<template>
  <div
    v-if="!printerFriendly"
    id="divLogiSelector"
    class="LogiSelector mb0">
    <div class="container-fluid filterContainer">
      <div class="row rd-gridsystem-scrollbar-wrap">
        <div class="rdResponsiveColumn col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="container-fluid filterContainer pl-0">
            <div class="row">
              <div class="rdResponsiveColumn col-lg-2 col-md-2 col-sm-4 col-xs-12">
                <span
                  class="rdThemeInputCaption b">Compare By:</span>
              </div>
            </div>
            <div class="row">
              <fieldset class="hideFieldset col-12">
                <legend class="accessibleHide">Compare By</legend>
                <div class="rdResponsiveColumn col-lg-2 col-md-2 col-sm-2 col-xs-12">
                  <input
                    id="irbLocation"
                    v-model="GS.reportType"
                    value="Locations"
                    type="radio"
                    name="optradio">
                  <label
                    for="irbLocation"
                    class="normal">Location</label>
                </div>
                <div class="rdResponsiveColumn col-lg-4 col-md-4 col-sm-5 col-xs-12 ">
                  <input
                    id="irbDemographics"
                    v-model="GS.reportType"
                    value="Demographics"
                    type="radio"
                    name="optradio">
                  <label
                    for="irbDemographics"
                    class="normal" >Demographics</label>
                  <label
                    for="islDemographicsCategory"
                    class="accessibleHide">Demographics Category</label>
                  <select
                    id="islDemographicsCategory"
                    :disabled="GS.reportType !== 'Demographics'"
                    v-model="GS.stratCatId"
                    style="width: 150px;"
                    class="rdThemeInput">
                    <option
                      v-for="item in demographics"
                      :key="'D'+ item.id"
                      :value="item.id"
                    >{{ item.name }}</option>
                  </select>
                </div>
                <div class="rdResponsiveColumn col-lg-3 col-md-3 col-sm-4 col-xs-12">
                  <input
                    id="irbYear"
                    v-model="GS.reportType"
                    value="Years"
                    type="radio"
                    name="optradio">
                  <label
                    for="irbYear"
                    class="normal">Year</label >
                  <label
                    for="islYear"
                    class="accessibleHide">Year</label>
                  <select
                    id="islYear"
                    :disabled="GS.reportType !== 'Years'"
                    v-model="GS.yearId"
                    style="width: 150px;"
                    class="rdThemeInput">
                    <option
                      v-for="item in years"
                      :key="item.id"
                      :value="item.id"
                    >{{ item.name }}</option>
                  </select>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      <div class="row rd-gridsystem-scrollbar-wrap">
        <div class="rdResponsiveColumn col-lg-2 col-md-2 col-sm-2 col-xs-12">
          <div>
            <label
              for="islLocation"
              class="rdThemeInputCaption">Location:</label>
            <select
              id="islLocation"
              v-model="GS.locationId"
              class="rdThemeInput">
              <option
                v-for="item in locations"
                :value="item.id"
                :key="'L' + item.id"
              >{{ item.name }}</option>
            </select>
          </div>
        </div>
        <div class="rdResponsiveColumn col-lg-1 col-md-2 col-sm-2 col-xs-12">
          <div style="padding-top: 8px; padding-bottom: 4px;">
            <div id="divGoBtn">
              <input
                :class="{ButtonDisabled: !goEnabled}"
                type="button"
                value="GO"
                class="span2"
                @click="goButtonClicked">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
// import api from '../../api';
import helper from '../../helper';

export default {
  data() {
    return {
      GS: {
        reportType: this.getDefaultFromQueryStringParmIfInitialPageLoad('Locations', 'ReportType'),
        locationId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'LocationId'),
        stratCatId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'StratCatId'),
        yearId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'YearId'),
      },
    };
  },
  computed: {
    ...mapState({
      initialPageLoad: state => state.flags.initialPageLoad,
      spgsLink: state => state.spgsLink,
      lku: state => state.lku,
      // showReportBody: state => state.CR.showReportBody,
      GSGo: state => state.CR.GSGo,
      loadingInitialApiData: state => state.flags.loadingInitialApiData,
      compareColumns: state => state.CR.compareColumns,
    }),
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    locations() {
      const list = _(this.spgsLink).map('l').uniq().map(l => this.lku.Location[l])
        .orderBy('sort', 'asc')
        .value();
      return helper.addSelectOne(list);
    },
    demographics() {
      const list = _(this.lku.StratificationCategory).filter(sc => sc.id === 'AGEGRP' || sc.id === 'RACE' || sc.id === 'SEX').orderBy('sort', 'asc').value();
      return helper.addSelectOne(list);
    },
    years() {
      const list = _(this.lku.Year).orderBy('sort', 'desc').value();
      if (list.length > 1) list.unshift({ id: 'RECENT', name: 'Recent 5 Years', sort: 999 });
      return helper.addSelectOne(list);
    },
    compareColumnsAllCategories() {
      switch (this.compareType) {
        case 'Locations':
          return _(this.CRData1).map('l').uniq().compact()
            .map(l => this.lku.Location[l])
            .orderBy('sort', 'asc')
            .value();
        case 'Demographics':
          return _(this.CRData1).map('s2').uniq().compact()
            .map(s => this.lku.Stratification[s])
            .orderBy('sort', 'asc')
            .value();
        case 'Years':
          return _(this.CRData1).map('y').uniq().compact()
            .map(y => this.lku.Year[y])
            .orderBy('sort', 'desc')
            .value();
        default:
          return [];
      }
    },
    goEnabled() {
      return (this.GS.reportType === 'Locations' && this.GS.locationId)
        || (this.GS.reportType === 'Demographics' && this.GS.stratCatId && this.GS.locationId)
        || (this.GS.reportType === 'Years' && this.GS.yearId && this.GS.locationId);
    },
  },
  watch: {
    loadingInitialApiData() {
      if (!this.loadingInitialApiData) {
        // initial api data has loaded

        // correct the GS inputs if invalid entries were selected via the query string args
        this.GS.reportType = _.indexOf(['Locations', 'Demographics', 'Years'], this.GS.reportType) === -1 ? 'Locations' : this.GS.reportType;
        this.GS.locationId = helper.defaultOrFirstId(this.locations, this.GS.locationId, true);
        this.GS.stratCatId = helper.defaultOrFirstId(this.demographics, this.GS.stratCatId, true);
        this.GS.yearId = helper.defaultOrFirstId(this.years, this.GS.yearId, true);

        // When the app is started on the CR route, the created
        // event fires before the initial api data is loaded. This watch
        // auto clicks the Go button when the initial api data load completes.
        this.autoClickGoButtonIfInitialPageLoad();
      }
    },
  },
  created() {
    // initialize the GS state from the previous GSGo state from the CR store
    // if not initial page load
    if (!this.initialPageLoad) {
      this.GS.reportType = this.GSGo.reportType;
      this.GS.locationId = this.GSGo.locationId;
      this.GS.stratCatId = this.GSGo.stratCatId;
      this.GS.yearId = this.GSGo.yearId;
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
    }
    // Auto click Go if loadingInitialApiData has completed before the created event.
    if (!this.loadingInitialApiData) {
      this.autoClickGoButtonIfInitialPageLoad();
    }
  },
  methods: {
    goButtonClicked() {
      if (this.goEnabled) {
        this.$store.commit('CR/setGSGo', this.GS);
        this.$store.dispatch('CR/triggerInteraction', { type: 'CRT' });
        this.$store.commit('CR/clearColumnsSearchAndReportOptions');

        if (this.initialPageLoad && this.GSGo.reportType !== 'Demographics') {
          // this call will set state.CR.compareColumns from query string parm:
          this.$store.dispatch('CR/setNonGSStateFromQueryStringIfValid');
        }

        if (this.compareColumns.length === 0) {
          let compareColumns;
          switch (this.GSGo.reportType) {
            case 'Locations':
              compareColumns = [this.lku.Location[this.GSGo.locationId]];
              break;
            case 'Demographics':
              // we display all strat id's returned from the api call, so compareColumns is set after the api call completes
              compareColumns = [];
              break;
            case 'Years':
              if (this.GSGo.yearId === 'RECENT') {
                compareColumns = _(this.lku.Year).orderBy('sort', 'desc').take(5)
                  .value();
              } else {
                compareColumns = [this.lku.Year[this.GSGo.yearId]];
              }
              break;
            default:
              compareColumns = [];
          }
          this.$store.commit('CR/setCompareColumns', compareColumns);
        }
        // get the crData from the api, then show (expand) the first category
        this.$store.dispatch('CR/getCRData', true)
          .then(() => {
            this.$store.commit('CR/setShowReportBody', true);
            if (this.initialPageLoad) {
              this.$store.dispatch('CR/setNonGSStateFromQueryStringIfValid');
              this.$store.commit('setInitialPageLoad', false);
            }
            // nextTick ensures the QS reflects the final CR state as a result of the getCRData
            this.$nextTick()
              .then(this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router));
          });
      }
    },
    getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey) {
      return this.$store.getters
        .getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey);
    },
    autoClickGoButtonIfInitialPageLoad() {
      if (this.initialPageLoad) {
        this.goButtonClicked();
      } else {
        this.$store.commit('setInitialPageLoad', false);
      }
    },
  },
};

</script>

<style scoped>
  .hideFieldset {
    border: none;
    padding: 0;
    /* display: inline;
    padding: 0; */
  }

  .normal {
    font-weight: normal;
  }

  .mb0 {
    margin-bottom: 0;
  }

  .LogiSelector label {
    display: inline;
    padding-right: 4px;
  }

  .b {
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/CR/CRGlobalSelector.vue